import Vue from 'vue';
import Router from 'vue-router';
import routers from './router';
import menuConfig from '../config/menuConfig';
import store from '@/store';
import changTitle from '../libs/changTitle';
import { commonServer } from '@/API/home';
import Cookies from 'js-cookie';
// 解决初次直接加载子站，然后返回主站页面后，导致样式被移除问题，该问题可能会随着 qiankun更新而被修复 临时解决方案
const childRoute = [];
if (window.QIANKUN_REGIST_APP_CONFIG) {
  window.QIANKUN_REGIST_APP_CONFIG.forEach((item) => {
    childRoute.push(item.activeRule);
  });
}
const isChildRoute = path => childRoute.some(item => path.startsWith(item));
const rawAppendChild = HTMLHeadElement.prototype.appendChild;
const rawAddEventListener = window.addEventListener;
Vue.use(Router);
const RouterConfig = {
  mode: 'history',
  base: window._env_.VUE_APP_BASEURL, // '/app/market-activity-vue/',
  routes: [
    {
      path: '/',
      name: '/',
      redirect: '/home'
    },
    {
      path: '*',
      name: '*',
      redirect: '/404'
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/components/page404')
    },
    {
      path: '/401',
      name: '401',
      component: () => import('@/components/page401')
    },
    {
      path: '/qdSignContract',
      name: 'qdSignContract',
      component: () => import('@/components/qdSignContract')
    },
    {
      path: '/qdSignContractDetail',
      name: 'qdSignContractDetail',
      component: () => import('@/components/qdSignContractDetail')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/home.vue')
    },
    // ruleConfiguration
    {
      path: '/ruleConfiguration',
      name: 'ruleConfiguration',
      component: () => import('@/views/newApplicationForm/ruleConfiguration.vue')
    },
    {
      path: '/htDetails',
      name: '/htDetails',
      component: () => import('@/views/htDetails/index.vue')
    }
  ]
};
const router = new Router(RouterConfig);

/**
 * 处理menuConfig中的菜单显隐
 * @param authList
 * @param menuList
 * @returns {[]}
 * @author xutianjiao
 */
function dealMenuFun (authList, menuList) {
  // 判断是否是锐捷员工，如果不是则将部分菜单隐藏
  const routesArr = [];
  const isSimplifiedUI = store.state.useSimplifiedUI;
  // 简化UI需要隐藏的菜单项 name 列表
  const SIMPLIFIED_UI_HIDDEN_MENUS = new Set([
    'industryReportApplication', // 行业报备申请
    'regionReportApplication', // 区域报备申请
    'industryReportList', // 行业报备列表
    'regionReportList', // 区域报备列表
    'annualMarketingPlan' // 年度营销规划
  ]);
  menuList.forEach(item => {
    let menuItem = authList.find(i => i.path === item['name']);
    if (item['children']) {
      if (menuItem) {
        // 递归组合路由
        item['hidden'] = false;
        item['meta']['title'] = menuItem['title'];
      }
      item['children'] = dealMenuFun(authList, item['children']);
    }
    if (menuItem) {
      // 递归组合路由
      item['hidden'] = false;
      item['meta']['title'] = menuItem['title'];
    }
    // 简化UI用户：对目标菜单强制隐藏（后置过滤，优先级高于权限匹配）
    if (isSimplifiedUI && SIMPLIFIED_UI_HIDDEN_MENUS.has(item['name'])) {
      item['hidden'] = true;
    }
    routesArr.push(item);
  });
  // 将原菜单数据进行添加，以保证结构的完整
  return routesArr;
};

/**
 * 处理routers中的权限的控制
 * @param authList 权限列表（后端获取）
 * @param routerList 路由列表（前端配置）
 * @returns {[]}
 * @author xutianjiao
 */
function dealMenuRouterFun (authList, routerList) {
  const routersArr = [];
  // routerList.forEach(item => {
  //   // 如果routers中的路径在权限列表中，则添加
  //   if (authList.includes(item['name'])) {
  //     if (item['children']) {
  //       // 递归组合路由
  //       item['children'] = dealMenuRouterFun(item['children']);
  //     }
  //     // 将处理后的菜单进行添加
  //     routersArr.push(item);
  //   }
  // });
  routerList.forEach(item => {
    // 如果routers中的路径在权限列表中，则添加
    let menuItem = authList.find(i => i.path === item['name']);
    if (menuItem) {
      if (item['children']) {
        // 递归组合路由
        item['children'] = dealMenuRouterFun(item['children']);
      }
      // 将处理后的菜单进行添加
      routersArr.push(item);
    }
  });
  // 将原菜单数据进行添加，以保证结构的完整
  return routersArr;
};

/**
 * 菜单权限的控制
 * @author xutianjiao
 */
export function menuAuthHandle (next) {
  return new Promise((resolve, reject) => {
    let auth = [];
    // 获取人员有权限的路由path
    commonServer.getRouterAuth().then((res) => {
      if (res.status === '200') {
        store.commit('routerMenu/setRouterList', res.data);
        auth = res.data.map(item => {
          // return item.path
          return {
            path: item.path,
            title: item.pathName
          };
        });
      }
      commonServer.getTicketEncrypt().then(res => {
        const ticket = window.encodeURIComponent(res.data);
        const routeLink = `${window._env_.VUE_APP_HT_URL}/rjevent/toRedEnvelopeList?data=${ticket}`;
        try {
          // 1.把处理完后的菜单值赋值vuex,以在APP中使用
          let menuConfigNew = dealMenuFun(auth, menuConfig);
          menuConfigNew.forEach(item => {
            if (item.name === 'relatedLinks') {
              item.children.forEach(ite => {
                if (ite.name === 'HT') {
                  ite.path = routeLink;
                  return; // 提前终止当前迭代
                };
              });
            }
          });
          store.commit('routerMenu/setMenuConfig', menuConfigNew);
          // 处理路由列表
          let routersNew = dealMenuRouterFun(auth, routers);
          router.addRoutes(routersNew);
          resolve();
        } catch (e) {
          console.error(e);
        }
      });
    });
  });
}

router.beforeEach((to, from, next) => {
  // 路由跳转前拦截
  // 2.进入页面第二步;
  store.commit('setSubPageLoading', true);
  if (Object.keys(store.state.userInfo).length > 0) {
    next();
  }
  // 3.判断页面需要高亮的左侧菜单路由
  if (to.query.metaActive) {
    // 如果跳转后的页面存在指定的需要高亮的指定菜单路由
    to.meta.active = to.query.metaActive;
  }

  // 从子项目跳转到主项目
  // if (isChildRoute(from.path) && !isChildRoute(to.path)) {
  //   HTMLHeadElement.prototype.appendChild = rawAppendChild;
  //   window.addEventListener = rawAddEventListener;
  // }
});
router.afterEach((to) => {
  // 路由跳转后
  if (to.meta.title) {
   // changTitle(to.meta.title, process.env.BASE_URL);
  }
  store.commit('setSubPageLoading', false);
});
export default router;
